import request from 'request';

const URL = document.domain !== 'locator.infusioncenter.org' ? "https://us-central1-infusion-center-locator-dev.cloudfunctions.net" : "https://us-central1-infusion-center-locator.cloudfunctions.net";

class StripeApi {

    findCustomerByEmail(email) {
        return new Promise((resolve, reject) => {
            request(`${URL}/getCustomerByEmail?email=${email}`, (error, response, body) => {
                if (response.statusCode === 200) {
                    resolve(JSON.parse(body));
                } else {
                    reject({code: response.statusCode, response: body, error: error});
                }
            });
        });
    }

    createCustomer(email, token) {
        return new Promise((resolve, reject) => {
            let formData = {
                email: email,
                token: token
            };
            request.post({
                url:`${URL}/createCustomer`,
                form: formData
            }, (error, response, body) => {
                if (response.statusCode === 200) {
                    resolve(JSON.parse(body));
                } else {
                    reject({code: response.statusCode, response: body, error: error});
                }
            });
        });
    }

    cancelSubscription(subscription) {
        return new Promise((resolve, reject) => {
            let formData = {
                subscription: subscription
            };
            request.post({
                url:`${URL}/cancelSubscription`,
                form: formData
            }, (error, response, body) => {
                if (response.statusCode === 200) {
                    resolve(JSON.parse(body));
                } else {
                    reject({code: response.statusCode, response: body, error: error});
                }
            });
        });
    }

}

let api = new StripeApi();

export default api;




// WEBPACK FOOTER //
// ./src/api/StripeApi.js